<template>
  <div class="login-failed">
    <i class="mdi mdi-alert-circle ta--text-error"></i>
    <p class="error-title">登录失败，请尝试刷新页面</p>
    <p class="error-desc" v-if="$store.state.errMsg">{{$store.state.errMsg}}</p>
  </div>
</template>

<script>
  export default {
    name: "LoginFailed"
  }
</script>

<style lang="scss" scoped>
  .login-failed {
    padding: 60px;
    background: #fff;
    display: flex;
    flex-direction: column;
    .mdi {
      color: $error;
      /*color: var(--error);*/
      font-size: 60px;
    }
    .error-title {
      color: #333;
      font-size: 16px;
      margin-top: 10px;
    }
    .error-desc {
      color: #666;
      font-size: 12px;
      margin-top: 10px;
    }
  }

</style>